<template>
	<div class="team-member">
		<div class="team-member-image">
			<Image v-if="member.image" :image="member.image" />
		</div>

		<div v-if="member.fullName" class="team-member-name">
			{{ sanitizeContent(member.fullName) }}
		</div>

		<div v-if="member.jobTitle" class="team-member-title">
			{{ sanitizeContent(member.jobTitle) }}
		</div>

		<div v-if="member.fullName" class="team-member-contact">
			<a :href="`mailto:${member.email}`">
				{{ sanitizeContent(member.email) }}
			</a>
		</div>

		<Button v-on:click.prevent="showBio" v-if="member?.cta && bio.length" :data="member?.cta?.fields" :data-id="id"/>
	</div>
</template>

<script setup>
import {useSanitize} from "~~/composables/useSanitize.js";
import { useTeamMemberCloseBio } from '~~/composables/useTeamMemberCloseBio.js';
import { useTeamMemberGetBio } from '~~/composables/useTeamMemberGetBio.js';
const { $eventBus } = useNuxtApp();
const { sanitizeContent } = useSanitize();
const  { content, id } = defineProps({
	id: String,
	bioContent: Object,
	content: {
		type: Object,
		required: true
	}
});
const member = computed(() => content ?? {});
const bio = computed(() => content?.bio?.content || []);
const pushBioContent = useTeamMemberGetBio();
const showBio = (event) => {
	bio.value.id = id;

	pushBioContent.value = bio.value;
};
</script>